import { Kind } from "graphql";
function findOperationDefinition(doc) {
    return doc.definitions.find((def)=>def.kind === Kind.OPERATION_DEFINITION);
}
export function getOperationName(doc) {
    var _findOperationDefinition_name, _findOperationDefinition;
    var _findOperationDefinition_name_value;
    return (_findOperationDefinition_name_value = (_findOperationDefinition = findOperationDefinition(doc)) === null || _findOperationDefinition === void 0 ? void 0 : (_findOperationDefinition_name = _findOperationDefinition.name) === null || _findOperationDefinition_name === void 0 ? void 0 : _findOperationDefinition_name.value) !== null && _findOperationDefinition_name_value !== void 0 ? _findOperationDefinition_name_value : null;
}
export function getOperationType(doc) {
    var _findOperationDefinition;
    var _findOperationDefinition_operation;
    return (_findOperationDefinition_operation = (_findOperationDefinition = findOperationDefinition(doc)) === null || _findOperationDefinition === void 0 ? void 0 : _findOperationDefinition.operation) !== null && _findOperationDefinition_operation !== void 0 ? _findOperationDefinition_operation : null;
}

//# sourceMappingURL=gql.js.map